import { useQuery, QueryObserverBaseResult } from "react-query"
import { queryKeys } from "../query"
import api from "../client"
import { GetOrderSummaryResponseData } from "../types/order"

const getData = async (uuid: string | undefined) => {
  const { data } = await api.get(`/orders/${uuid}/summary`)
  return data
}

export const useOrderSummary = (uuid: string | undefined):
  QueryObserverBaseResult<GetOrderSummaryResponseData> => {
  const { data, ...props } = useQuery<GetOrderSummaryResponseData>(
    queryKeys.ORDER_SUMMARY(uuid),
    () => getData(uuid),
    { enabled: Boolean(uuid) }
  )
  return { data, ...props }
}
